import { useSearchParams } from 'react-router-dom';
import moment from 'moment';

export const useInvestigationDateUrlUpdate = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateDatesInUrl = (
    dates1: [moment.Moment, moment.Moment] | null,
    dates2: [moment.Moment, moment.Moment] | null,
  ) => {
    const newParams = new URLSearchParams(searchParams);

    if (dates1 && dates1[0] && dates1[1]) {
      newParams.set('timestamp1Start', dates1[0].valueOf().toString());
      newParams.set('timestamp1End', dates1[1].valueOf().toString());
    } else {
      newParams.delete('timestamp1Start');
      newParams.delete('timestamp1End');
    }

    if (dates2 && dates2[0] && dates2[1]) {
      newParams.set('timestamp2Start', dates2[0].valueOf().toString());
      newParams.set('timestamp2End', dates2[1].valueOf().toString());
    } else {
      newParams.delete('timestamp2Start');
      newParams.delete('timestamp2End');
    }

    setSearchParams(newParams, { replace: true });
  };

  return { updateDatesInUrl };
};
